/**
 * Created by wuyanbin on 2019/5/25
 */
/**
 * 与后端的关系映射表
 */
// excel 导出类型
const excelExportType = {
    order_wait_contract: {
        label: '订单管理-待买家签署合同',
        value: 'order_wait_contract',
    },
    order_wait_pay: {
        label: '订单管理-待付款车辆',
        value: 'order_wait_pay',
    },
    order_wait_transfer: {
        label: '订单管理-交付中车辆',
        value: 'order_wait_transfer',
    },
    order_win_bidding: {
        label: '订单管理-中标车辆',
        value: 'order_win_bidding',
    },
    transaction_pay_wait_apply: {
        label: '订单管理-交易完结-卖家付款待申请',
        value: 'transaction_pay_wait_apply',
    },
    transaction_pay_apply_ing: {
        label: '订单管理-交易完结-卖家付款申请中',
        value: 'transaction_pay_apply_ing',
    },
    transaction_pay_refund: {
        label: '订单管理-交易完结-卖家付款已驳回',
        value: 'transaction_pay_refund',
    },
    transaction_pay_pass: {
        label: '订单管理-交易完结-卖家付款已通过',
        value: 'transaction_pay_pass',
    },
    transaction_fail_car: {
        label: '订单管理-交付中止车辆',
        value: 'transaction_fail_car',
    },
    dispute_wait: {
        label: '订单管理-争议管理-待处理',
        value: 'dispute_wait',
    },
    dispute_end: {
        label: '订单管理-争议管理-已处理',
        value: 'dispute_end',
    },
    payment_buyer_all: {
        label: '财务管理-付款管理-买家付款管理-全部',
        value: 'payment_buyer_all',
    },
    payment_buyer_wait: {
        label: '财务管理-付款管理-买家付款管理-待付款',
        value: 'payment_buyer_wait',
    },
    payment_buyer_end: {
        label: '财务管理-付款管理-买家付款管理-已付款',
        value: 'payment_buyer_end',
    },
    payment_seller_all: {
        label: '财务管理-付款管理-卖家打款管理-全部',
        value: 'payment_seller_all',
    },
    payment_seller_apply: {
        label: '财务管理-付款管理-卖家打款管理-待审批',
        value: 'payment_seller_apply',
    },
    payment_seller_refund: {
        label: '财务管理-付款管理-卖家打款管理-已驳回',
        value: 'payment_seller_refund',
    },
    payment_seller_pass: {
        label: '财务管理-付款管理-卖家打款管理-已通过',
        value: 'payment_seller_pass',
    },
    goods_deal_fail_data: {
        label: '车辆管理-交易结束车辆-交易失败车辆',
        value: 'goods_deal_fail_data',
    },
    goods_deal_success_data: {
        label: '车辆管理-交易结束车辆-交易成功车辆',
        value: 'goods_deal_success_data',
    },
    goods_offline_data: {
        label: '车辆管理-下线车辆',
        value: 'goods_offline_data',
    },
    goods_fail_auction_data: {
        label: '车辆管理－流拍车辆',
        value: 'goods_fail_auction_data',
    },
    auction_doing_data: {
        label: '拍卖管理-拍卖中车辆',
        value: 'auction_doing_data',
    },
    withdraw_init_data: {
        label: '财务管理-提现管理-待审批',
        value: 'withdraw_init_data',
    },
    withdraw_accept_data: {
        label: '财务管理-提现管理-已通过',
        value: 'withdraw_accept_data',
    },
    withdraw_reject_data: {
        label: '财务管理-提现管理-已驳回',
        value: 'withdraw_reject_data',
    },
    auction_wait_deal_data: {
        label: '车辆管理-待成交车辆',
        value: 'auction_wait_deal_data',
    },
    buyer_deposit_data: {
        label: '财务管理-买家保证金',
        value: 'buyer_deposit_data',
    },
    seller_deposit_data: {
        label: '财务管理-卖家保证金',
        value: 'seller_deposit_data',
    },
    seller_detail_data: {
        label: '财务管理-卖家保证金明细',
        value: 'seller_detail_data',
    },
    buyer_detail_data: {
        label: '财务管理-买家保证金明细',
        value: 'buyer_detail_data',
    },
    round_monitor_data: {
        label: '竞拍管理-场次监控',
        value: 'round_monitor_data',
    },
    round_auction_monitor_data: {
        label: '竞拍管理-场次数据详情',
        value: 'round_auction_monitor_data',
    },
    round_auction_monitor_data_forCar: {
        label: '竞拍管理-车辆详细数据',
        value: 'round_auction_monitor_data',
    },
};
// 买家类型
const buyerType = [
    {
        label: '全部',
        value: '',
    },
    {
        label: '网络',
        value: '1',
    },
    {
        label: '现场',
        value: '0',
    },
];
// 收款状态
const gatheringStatus = [
    {
        label: '全部',
        value: '',
    },
    {
        label: '待申请',
        value: '0',
    },
    {
        label: '待确认',
        value: '1',
    },
];
// 导出的权限配置
const exportAllow = {
    psgjb_carpend_exporting: {
        label: '车辆管理-全部待审批导出',
        value: 'psgjb-carpend-exporting',
    },
    psgjb_carthrough_exporting: {
        label: '车辆管理-全部审批成功导出',
        value: 'psgjb-carthrough-exporting',
    },
    psgjb_carreject_export: {
        label: '车辆管理-全部审批驳回导出',
        value: 'psgjb-carreject-export',
    },
    psgjb_carpendmine_export: {
        label: '车辆管理-我的待审批导出',
        value: 'psgjb-carpendmine-export',
    },
    psgjb_carthromine_export: {
        label: '车辆管理-我的审批成功导出',
        value: 'psgjb-carthromine-export',
    },
    psgjb_carrejectmine_export: {
        label: '车辆管理-我的审批驳回导出',
        value: 'psgjb-carrejectmine-export',
    },
    psgjb_carstate_exporting: {
        label: '车辆管理-车辆状态查询导出',
        value: 'psgjb-carstate-exporting',
    },
    psgjb_carfail_exporting: {
        label: '车辆管理-流拍车辆导出',
        value: 'psgjb-carfail-exporting',
    },
    psgjb_cartradend_export: {
        label: '车辆管理-交易结束车辆导出',
        value: 'psgjb-cartradend-export',
    },
    psgjb_artoffline_export: {
        label: '车辆管理-下线车辆导出',
        value: 'psgjb-cartoffline-export',
    },
    psgjb_cartransacpend_export: {
        label: '车辆管理-待成交车辆导出',
        value: 'psgjb-cartransacpend-export',
    },
    psgjb_auctioncar_export: {
        label: '拍卖管理-拍卖中车辆导出',
        value: 'psgjb-auctioncar-export',
    },
    psgjb_ordercontrasign_export: {
        label: '订单管理-待买家签署合同导出',
        value: 'psgjb-ordercontrasign-export',
    },
    psgjb_ordervolume_export: {
        label: '订单管理-交易完结车辆导出',
        value: 'psgjb-ordertransfer-jiaoyiwanjieexport',
    },
    psgjb_orderobili_export: {
        label: '订单管理-待付款车辆导出',
        value: 'psgjb-orderobili-export',
    },
    psgjb_ordertransfer_export: {
        label: '订单管理-交付中车辆导出',
        value: 'psgjb-ordertransfer-export',
    },
    psgjb_orderfail_export: {
        label: '订单管理-交付中止车辆导出',
        value: 'psgjb-orderfail-export',
    },
    psgjb_orderwinbid_export: {
        label: '订单管理-中标车辆',
        value: 'psgjb-orderwinbid-export',
    },
    psgjb_finanbupayment_export: {
        label: '财务管理-买家付款管理导出',
        value: 'psgjb-finanbupayment-export',
    },
    psgjb_finansepayment_export: {
        label: '财务管理-卖家打款管理导出',
        value: 'psgjb-finansepayment-export',
    },
    psgjb_finanwithdraw_export: {
        label: '财务管理-提现管理导出',
        value: 'psgjb-finanwithdraw-export',
    },
    psgjb_dealerbuyer_export: {
        label: '经销商管理-买家经销商列表导出',
        value: 'psgjb-dealerbuyer-export',
    },
    psgjb_dealerseller_export: {
        label: '经销商管理-卖家经销商列表导出',
        value: 'psgjb-dealerseller-export',
    },
    psgjb_jpgl_export: {
        label: '竞拍管理-导出',
        value: 'psgjb-jpgl-export',
    },
    psgjb_jpgl_clxxsj_export: {
        label: '竞拍管理-导出车辆详细数据',
        value: 'psgjb-jpgl-clxxsj-export',
    },
};
// 竞拍状态
const auctionState = {
    30: '竞拍暂停中',
    8: '应价',
    80: '应价暂停中',
    50: '待成交',
    51: '待成交',
    81: '加价师应价中',
    1: '预展中',
    2: '待开拍',
    3: '竞拍中',
    4: '结束',
    5: '已成交',
    6: '已流拍',
    7: '下架',
};
// 基础数据查询键值对
const setRuleKeyVal = {
    isOpenBidConfirm: {
        label: '是否开启中标确认',
        value: '110',
    },
};
export default {
    excelExportType,
    buyerType,
    gatheringStatus,
    exportAllow,
    auctionState,
    setRuleKeyVal,
};
